export default {
  blogContent: {
    title1: "MAHAL",
    title2: "Insights",

    desc:
      "Stories, insights, and updates from the B2B food ecosystem.",

    readMore: "Read Article",

    blogs: [
      {
        category: "Industry Insights",
        title: "How Restaurants Can Optimize Daily Procurement",
      },
      {
        category: "Supply Chain",
        title: "Building Reliable Supplier Networks in B2B Food",
      },
      {
        category: "Operations",
        title: "Reducing Food Costs Without Compromising Quality",
      },
      {
        category: "Marketplace",
        title: "Why Digital Marketplaces Are the Future of Food Supply",
      },
      {
        category: "Restaurants",
        title: "Bulk vs Daily Ordering: What Works Best?",
      },
      {
        category: "Suppliers",
        title: "How Suppliers Can Scale Faster Using MAHAL",
      },
      {
        category: "Logistics",
        title: "Ensuring On-Time Delivery in High-Volume Orders",
      },
      {
        category: "Technology",
        title: "How Data Improves Transparency in B2B Procurement",
      },
      {
        category: "Growth",
        title: "Long-Term Partnerships Between Restaurants & Suppliers",
      },
    ],
  },
};